import { useMutation } from "@tanstack/react-query";
import { requests } from "./requests";
import { useApiToast } from "@/hooks/apiCall";

export const queries = {
  // Add your queries here if needed
};

export const useMutations = () => {
  const { onSuccess, onError } = useApiToast(requests.key);

  const acceptTermsOfService = useMutation({
    mutationFn: async () => {
      const res = await requests.acceptTermsOfService();
      return res;
    },
    onSuccess,
    onError,
  });

  const acceptPrivacyPolicy = useMutation({
    mutationFn: async () => {
      const res = await requests.acceptPrivacyPolicy();
      return res;
    },
    onSuccess,
    onError,
  });

  const resetTermsOfService = useMutation({
    mutationFn: async () => {
      const res = await requests.resetTermsOfService();
      return res;
    },
    onSuccess,
    onError,
  });

  const resetPrivacyPolicy = useMutation({
    mutationFn: async () => {
      const res = await requests.resetPrivacyPolicy();
      return res;
    },
    onSuccess,
    onError,
  });

  return {
    acceptTermsOfService,
    acceptPrivacyPolicy,
    resetTermsOfService,
    resetPrivacyPolicy,
  };
};
